import * as yup from 'yup';
import { MomentInput } from 'moment';
import moment from "./momentConfig";

const DATE_FORMAT = 'DD/MM/YYYY';
const MIN_VALID_YEAR = 1900;

function parseDateValue(originalValue: unknown) {
    if (typeof originalValue !== 'string') {
        const parsedDate = moment(originalValue as MomentInput);
        return parsedDate.isValid() && parsedDate.year() >= MIN_VALID_YEAR
            ? parsedDate.toDate()
            : new Date('');
    }

    const normalizedValue = originalValue.trim();

    if (!normalizedValue) {
        return new Date('');
    }

    const [day, month, year] = normalizedValue.split('/');

    if (!day || !month || !year || year.length !== 4) {
        return new Date('');
    }

    const parsedDate = moment(normalizedValue, DATE_FORMAT, true);

    return parsedDate.isValid() && parsedDate.year() >= MIN_VALID_YEAR
        ? parsedDate.toDate()
        : new Date('');
}

export interface Validator {
    isDate: boolean,
    isOptionalDate: boolean,
    isNumeric: boolean,
    numberGreaterThanZero: boolean,
    isTime: boolean,
    isCEP: boolean,
    message: string
}

export function getValidator(validator: Partial<Validator>) {
    let itemValidator;

    if (validator.isDate) {
        itemValidator = yup.date()
            .transform((value, originalValue) => {
                return parseDateValue(originalValue);
            })
            .typeError(validator.message ? validator.message : 'Informe uma data');

        return itemValidator;
    }

    if (validator.isNumeric) {
        itemValidator = yup.number()
            .transform((value, originalValue) => {
                if (typeof originalValue === "string") {
                    const parsed = originalValue
                        .replace(/[R$\s]/g, "")
                        .replace(",", ".");

                    const num = parseFloat(parsed);
                    return isNaN(num) ? undefined : num;
                }
                return value;
            })
            .typeError('Informe apenas números')
            .max(1000000, `Máximo 999999 números`);
        
        if (validator.numberGreaterThanZero) {
            itemValidator = itemValidator.min(0.01, 'Valor deve ser maior que zero');
        }

        return itemValidator;
    }

    if (validator.isOptionalDate) {
        itemValidator = yup.date().nullable().default(null)
            .transform((value, originalValue) => {
                if (value == 'Invalid Date' && originalValue == 'Invalid Date') return null;
                if (originalValue == '') return null;
                return parseDateValue(originalValue);
            })
            .typeError(validator.message ? validator.message : 'Informe uma data');

        return itemValidator;
    }

    if (validator.isTime) {
        itemValidator = yup.string()
        .transform((value, originalValue) => {
            return moment(value, 'HH:mm').isValid() ? value : '';
        })
        .typeError('Informe uma hora válida');

        return itemValidator;
    }

    if (validator.isCEP) {
        itemValidator = yup.string()
            .required('CEP obrigatório')
            .matches(/^\d{5}-\d{3}$/, 'CEP inválido');            
        return itemValidator;
    }

    return yup.string();
}